import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

// '12/22' => '2022-12-31'
export function getCardExpirationDateForOrder(date?: string) {
  if (!date) return ''
  return dayjs(date, 'MM/YY').format('YYYY-MM-DD')
}

// '1999-01-01' => true
export function getIsCardExpired(date?: string) {
  if (!date) return false
  const { month, year } = getCardExpirationMonthYear(date)
  const isExpired = dayjs().isAfter(dayjs(`${year}-${month}-01`))
  return isExpired
}

// '2022-12-31' => { month: '12', year: '2022' }
export function getCardExpirationMonthYear(date?: string) {
  if (!date) return { month: '', year: '' }
  const [year, month] = date.split('-')
  return { month, year }
}

export function formatDate(date: string, datePattern: string) {
  return dayjs(date).format(datePattern)
}

export function minutesToMilliseconds(minutes: number) {
  return minutes * 60 * 1000
}
